/**
 * Web-side RBAC helpers for the Clients (Client 360) area.
 *
 * THIN ADAPTER over the single shared tier helper in `auth/tier.ts` — the same
 * pattern as `views/infrastructure/rbac.ts` (`canManageInfra`/`isInfraAdmin`).
 * The whole three-tier model (viewer / operator / admin) and the API-aligned
 * `currentUser.tier` resolution live in auth/tier.ts; this file only re-labels
 * the two gates the Client 360 tabs read:
 *   - canWriteClients  → operator OR admin (client/contact/module/tool/document
 *                         writes, notes, onboarding patches, archive)
 *   - isClientsAdmin   → admin only (restore + includeDeleted reads — matches
 *                         the API's requireAdminForRestore /
 *                         requireAdminForIncludeDeleted gates)
 *
 * SECURITY: a green light here is never sufficient — the organization-domain
 * services re-check the effective tier on every write (requireWriteAccess);
 * this only governs whether the UI renders the controls.
 */
import type RootStore from "stores/RootStore";
import { isOperator, isAdmin } from "auth/tier";

/** operator OR admin — may run any Client 360 write the API operator-gates. */
export function canWriteClients(rootStore: RootStore): boolean {
  return isOperator(rootStore);
}

/** admin ONLY — restore archived clients and read with `includeDeleted`. */
export function isClientsAdmin(rootStore: RootStore): boolean {
  return isAdmin(rootStore);
}
